﻿import React from 'react';
import { useWizard } from 'react-use-wizard';
import IconHelper from '@bazooka_se/lf-icons';

const WizardNavigation = (props) => {

    const { nextStep, activeStep, stepCount } = useWizard();

    return (   
        <span className="wizard__question__navigation">

            <span className="wizard__question__navigation__text">Skräddarsy dina uppgifter</span>
            <span className="wizard__question__navigation__count">{activeStep + 1} / {stepCount - 1}</span>

            {activeStep >= stepCount - 1 ?
                null : 
                <button onClick={() => nextStep()}>
                    <span dangerouslySetInnerHTML={{ __html: IconHelper('angle-right').outerHTML }}></span>
                </button>
            }
        </span>
     )
}

export default WizardNavigation;

